/* Excel-style arithmetic for editable numeric cells.
 * Accepts plain numbers OR expressions like (5*30)+12 / =4*8.
 * Safe: only digits, + - * / ( ) . and spaces are evaluated. */
export const ARITH_RE = /[+\-*/()=]/;

export function evalArithmetic(raw) {
    const s = String(raw).trim().replace(/^=/, "");
    if (s === "") return { ok: true, value: "" };
    if (!/^[\d+\-*/().\s]+$/.test(s)) return { ok: false, err: "Only digits and + − × ÷ ( ) allowed" };
    try {
        // eslint-disable-next-line no-new-func
        const out = Function(`"use strict"; return (${s});`)();
        if (typeof out !== "number" || !isFinite(out)) return { ok: false, err: "Invalid formula" };
        return { ok: true, value: Math.max(0, Math.round(out * 100) / 100) };
    } catch {
        return { ok: false, err: "Invalid formula" };
    }
}
